import axiosInstance from "../Axios";

function getLabourLawUsers(pageNo = 1, params = {}) {
  return axiosInstance.get("/labour-law/users", {
    params: { pageNo, ...params },
    responseType: params.export ? "blob" : "json",
  });
}

function getShiftHoursSummary(params) {
  try {
    return axiosInstance.get("labour-law/get-shift-hours-summary",{params});
  } catch (error) {
    console.log("error while fetching shift hours summary", error);
    throw error;
  }
}

function getTimelyWagesSummary(params) {
  try {
    return axiosInstance.get("labour-law/get-timely-wages-summary",{params});
  } catch (error) {
    console.log("error while fetching timely wages summary", error);
    throw error;
  }
}

function getPFSummary(params) {
  try {
    return axiosInstance.get("labour-law/get-pf-summary",{params});
  } catch (error) {
    console.log("error while fetching pf summary", error);
    throw error;
  }
}

function getESICSummary(params) {
  try {
    return axiosInstance.get("labour-law/get-esic-summary",{params});
  } catch (error) {
    console.log("error while fetching esic summary", error);
    throw error;
  }
}

function getOvertimeSummary(params){
  try {
    return axiosInstance.get("labour-law/get-overtime-summary",{params});
  } catch (error) {
    console.log("error while fetching overtime summary", error);
    throw error;
  }
}

function getBasicCTCSummary(params){
  try {
    return axiosInstance.get("labour-law/get-basic-ctc-summary",{params});
  } catch (error) {
    console.log("error while fetching basic ctc summary", error);
    throw error;
  }
}

function getSkillLevelSummary(params){
  try {
    return axiosInstance.get("labour-law/get-skill-level-summary",{params});
  } catch (error) {
    console.log("error while fetching skill level summary", error);
    throw error;
  }
}

function getHealthCheckSummary(params) {
  try {
    return axiosInstance.get("labour-law/get-health-check-summary",{params});
  } catch (error) {
    console.log("Error fetching health cehck summary:", error);
    throw error;
  }
}

function getDepartments() {
  try {
    return axiosInstance.get("/labour-law/departments"); // Active departments
  } catch (error) {
    console.log("Error fetching departments:", error);
    throw error;
  }
}

function getDesignations() {
  try {
    return axiosInstance.get("/labour-law/designations"); // Active designations
  } catch (error) {
    console.log("Error fetching designations:", error);
    throw error;
  }
}

function getOfficeLocations() {
  try {
    return axiosInstance.get("/labour-law/office-locations"); // Active office locations
  } catch (error) {
    console.log("Error fetching office locations:", error);
    throw error;
  }
}


async function addEditHealthCheck(formData) {
  try {
    return await axiosInstance.post(
      "/labour-law/health-add-edit",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (error) {
    console.error("Error adding/updating health check:", error);
    throw error;
  }
}

async function getHealthCheckDetails(userId, financialYear) {
  try {
    return await axiosInstance.get(
      `/labour-law/health-details/${userId}/${financialYear}`
    );
  } catch (error) {
    console.error("Error fetching health check details:", error);
    throw error;
  }
}

const downloadHealthCheckDocument = async (fileName) => {
  try {
    return await axiosInstance.get("/labour-law/health-download", {
      params: { fileName: fileName },
      responseType: "blob",
    });
  } catch (error) {
    console.error("Error downloading resignation document:", error);
    throw error;
  }
};

async function bulkUploadHealthZip(formData) {
  try {

    return await axiosInstance.post(
      "/labour-law/health-bulk-upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (error) {
    console.error("Error uploading bulk health document:", error);
    throw error;
  }
}

export {
  getLabourLawUsers,
  getTimelyWagesSummary,
  getHealthCheckSummary,
  getPFSummary,
  getESICSummary,
  getShiftHoursSummary,
  getOvertimeSummary,
  getBasicCTCSummary,
  getSkillLevelSummary,
  getDepartments,
  getDesignations,
  getOfficeLocations,
  addEditHealthCheck,
  getHealthCheckDetails,
  downloadHealthCheckDocument,
  bulkUploadHealthZip,
};
